import React from 'react'
import { TextLinkArrow } from 'newComponents'
import classNames from 'classnames'
import './styles.scss'

const ParagraphWithCta = ({ paragraphs, url, ctaText, hiddenCtaMobile }) => (
  <>
    {paragraphs}
    <div
      className={classNames('paragraph-cta', {
        'is-hidden-mobile': hiddenCtaMobile
      })}
    >
      <TextLinkArrow url={url} text={ctaText} />
    </div>
  </>
)

export default ParagraphWithCta
